<template>
  <div class="tasks-layout">
    <MobileHeader :label="$t('nav.tasks')" />
    <!-- Category Panel -->
    <div
      :class="{
        'tasks-layout__left': true,
        'show-for-medium': !categoriesVisible,
      }"
    >
      <ul class="tasks-layout__categories">
        <CategoryLink
          v-for="link in categories"
          :key="link.routeName"
          :options="link"
          @click="categoriesVisible = false"
        />
      </ul>
    </div>

    <div :class="{ 'tasks-layout__view': true, 'show-for-medium': categoriesVisible }">
      <router-view
        @showCategories="categoriesVisible = true"
        @updateCategoryCount="updateCount"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import I18n from 'i18n-js';

// Components
import MobileHeader from '@/components/generic/mobile_header.vue';
import CategoryLink from '@/components/tasks/category_link.vue';
import useAjax from '@/functions/use_ajax';

const props = defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: true },
});

const ajax = useAjax();

const categoriesVisible = ref(true);

/**
 * Category nav items
 */
const categories = reactive([
  {
    routeParams: 'all',
    name: 'tasksCategory',
    label: I18n.t('tasks.categories.all'),
    count: null,
  },
  {
    routeParams: 'current',
    name: 'tasksCategory',
    label: I18n.t('tasks.categories.current'),
    count: null,
  },
  {
    routeParams: 'past_due',
    name: 'tasksCategory',
    label: I18n.t('tasks.categories.past_due'),
    count: null,
  },
  {
    routeParams: 'completed',
    name: 'tasksCategory',
    label: I18n.t('tasks.categories.completed'),
    count: null,
  },
  {
    routeParams: 'issues_missing_tasks',
    name: 'taskIssuesCategory',
    label: I18n.t('tasks.categories.issues_missing_tasks'),
    count: null,
  },
  {
    routeParams: 'resolved_issues',
    name: 'taskIssuesCategory',
    label: I18n.t('tasks.categories.resolved_issues'),
    count: null,
  },
]);

/**
 * Emitted event to update category counts.
 * This gets triggered once the IssueList or TaskList component
 *  has successfully loaded it's data after mounting. (via router-view)
 */
async function updateCount() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/operations/${props.operationId}/plants/task_counts`);

  if (ok) {
    const updatedCounts = {
      all: data.all_tasks,
      current: data.current_tasks,
      past_due: data.overdue_tasks,
      completed: data.completed_tasks,
      issues_missing_tasks: data.issues_without_tasks,
      resolved_issues: data.issues_resolved,
    };

    categories.forEach((item) => {
      item.count = updatedCounts[item.routeParams];
    });
  }
}
</script>
